import React from 'react';
import SelectedCheckMark from '@assets/images/drivethru/selectedCheck.svg';
import DefaultLane from '@assets/images/drivethru/lane.png';
import cn from 'classnames';
import { TouchableButton } from '@components/common/Touchable/index';

const LaneSelection = ({ displayedLanes, selectedLane, onSelect }) => {
  if (displayedLanes.length === 0) return null;

  const calculateWidth = count => {
    const widths = { 1: '100%', 2: '47.5%', 3: '31.67%', 4: '23.75%' };
    return widths[count] || '100%';
  };

  return (
    <div className="d-flex mb-1">
      {displayedLanes.map((lane, index) => {
        if (lane?.menuItemId == null) return null;
        const isSelected = selectedLane === lane.menuItemId;
        const width = calculateWidth(displayedLanes.length);

        return (
          <TouchableButton
            key={lane.menuItemId}
            className={cn(
              'd-flex justify-content-center align-items-center px-2 br-2 border-0 position-relative'
            )}
            style={{
              width,
              marginRight: index < displayedLanes.length - 1 ? '4px' : '0',
              height: '40px',
            }}
            onClick={() => onSelect(lane.menuItemId)}
          >
            <img
              src={lane.imageUrl || DefaultLane}
              alt="Lane"
              style={
                lane.imageUrl
                  ? { width: 'auto', height: 'auto' }
                  : { width: '40px', height: '32px' }
              }
            />
            {isSelected && (
              <img
                src={SelectedCheckMark}
                alt="Selected"
                style={{ position: 'absolute', width: '14px', height: '14px' }}
              />
            )}
          </TouchableButton>
        );
      })}
    </div>
  );
};

export default LaneSelection;
